import { render, staticRenderFns } from "./CertificateRenderer.vue?vue&type=template&id=4a229022"
import script from "./CertificateRenderer.vue?vue&type=script&lang=js"
export * from "./CertificateRenderer.vue?vue&type=script&lang=js"
import style0 from "./CertificateRenderer.vue?vue&type=style&index=0&id=4a229022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports